import { checkStatus, fetchJson, defaultHeaders } from 'common/http';
import _ from 'lodash';

/**
 * Get user activity settings for the current domain
 * @returns {Promise<any | never>} Object of activity settings
 */
const getSettings = () => {
  const fetchOptions: RequestInit = {
    credentials: 'same-origin',
    headers: defaultHeaders
  };
  const apiPath = '/api/user_activity';
  return fetchJson(apiPath, fetchOptions)
    .then((response) => {
      const settings = response['inactivity_settings'];
      return {
        featureEnabled: settings['enabled'],
        sendEmailToInactiveUser: settings['email_detected_users'],
        threshold: settings['logging_threshold']
      };
    })
    .catch((error) => {
      return {
        error: error
      };
    });
};

/**
 *  This updates user activity settings for a domain
 * @param featureEnabled - The entire inactive user monitoring should be enabled on a domain
 * @param sendEmailToInactiveUser - Whether users that have been deem inactive receive emails about it
 * @param threshold - The number of days that users has not accessed the platform before being considering inactive
 * @returns {Promise<any | never>}
 */
export const updateSettings = (
  featureEnabled: boolean,
  sendEmailToInactiveUser: boolean,
  threshold: number
) => {
  const apiPath = '/api/user_activity';

  const body = {
    enabled: true,
    inactivity_settings: {
      email_detected_users: sendEmailToInactiveUser,
      enabled: featureEnabled,
      logging_threshold: threshold
    }
  };

  const fetchOptions: RequestInit = {
    credentials: 'same-origin',
    headers: defaultHeaders,
    method: 'POST',
    body: JSON.stringify(body)
  };

  return fetchJson(apiPath, fetchOptions);
};

export default {
  getSettings,
  updateSettings
};
